<template>
  <div v-if="data.articleType === 1" style="padding:20px">
    <h3>{{ data.articleTitle }}</h3>
    <div v-html="data.articleContent"></div>
  </div>
  <video v-else id="my-player" controls preload="auto" webkit-playsinline="true" playsinline="true"
    class="video-js vjs-big-play-centered vjs-fluid" autoplay>
    <p class="vjs-no-js">
      To view this video please enable JavaScript, and consider upgrading to a
      web browser that supports HTML5 video
    </p>
  </video>
</template>

<script>
import Vue from "vue";
import { Cell, CellGroup } from "vant";
import { post } from "@/utils/request";
import Video from "video.js";
import video_zhCN from "video.js/dist/lang/zh-CN.json";
import video_en from "video.js/dist/lang/en.json";
import "video.js/dist/video-js.css";
Video.addLanguage("zh-CN", video_zhCN);
Video.addLanguage("en", video_en);
Vue.use(Cell);
Vue.use(CellGroup);
export default {
  props: {},
  data() {
    return {
      data: []
    };
  },
  components: {

  },
  created() {
    post({
      url: '/article/open/articleInfo/findArticleDetail',
      data: {
        id: this.$route.query.id,
      }
    }).then(res => {
      if (res.code === 0) {
        this.data = res.data
        document.title = res.data.articleTitle

        if (res.data.articleType !==1) {
          var data = {
            src: res.data.videoUrl,
            type: "video/mp4",
            autoplay: true,
          };
          Video("my-player", data, function () {
            this.pause();
            this.src(data);
            this.load(data);
            this.play();
          });
        }
      }
    })
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>
h3 {
  text-align: center;
  margin-bottom: 10px;
}
.license {
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  // background-color: #ffffff;
  .img_wrap {
    padding: 10px;
  }

  .img_title {
    text-align: center;
    padding: 10px 0;
  }
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}

#my-player {
  width: 100%;
  height: 100vh;
}
</style>
